import React from "react";
import { DIVERSITY_LINKS, MOSAIC_IMAGES } from "../homeV2.constants";
import Reveal from "./Reveal";

const Diversity = () => {
  return (
    <section className="hv2-diversity" id="diversity">
      <div className="home-v2__container hv2-diversity__grid">
        <Reveal>
          <h2 className="home-v2__h2 hv2-diversity__title">
            Opportunity should look like <span className="home-v2__highlight">everyone</span>
          </h2>
          <p className="home-v2__body-lg hv2-diversity__sub">
            We&apos;re building a professional community where people can be discovered for what
            they bring to the table.
          </p>
          <div className="hv2-diversity__links">
            {DIVERSITY_LINKS.map((link) =>
              link.href ? (
                <a key={link.label} href={link.href}>
                  {link.label} →
                </a>
              ) : (
                <span key={link.label} className="hv2-diversity__link--inert">
                  {link.label} →
                </span>
              )
            )}
          </div>
        </Reveal>

        <Reveal delay={0.08} className="hv2-mosaic">
          {MOSAIC_IMAGES.map((tile) => (
            <div className="hv2-mosaic__tile" key={tile.src}>
              <img src={tile.src} alt={tile.alt} />
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Diversity;
